/* eslint-disable no-unused-vars */
export enum CompaniesActionType {
  GET_COMPANIES = 'get_companies',
  GET_COMPANIES_SUCCESS = 'get_companies_success',
  GET_COMPANIES_FAILURE = 'get_companies_failure',
}
